<script lang="ts">
  import { Button } from '@athena-lib/Button';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { Type } from '@sinclair/typebox';
  import { Spinner } from '@athena-lib/Icons';
  import { Paragraph } from '@athena-lib/Text';
  import { getShoppingCart } from '$lib/shopping-cart.svelte';
  import { post } from '$lib/http';
  import { getCheckoutSdk } from '$lib/checkout.svelte';

  const { orderId, sheetIds }: { orderId: string | null; sheetIds: Array<string> | undefined } =
    $props();

  const shoppingCart = getShoppingCart();
  const checkoutSdk = $derived(getCheckoutSdk());
  async function addSheetsToCart() {
    addToCartState = 'loading';
    if (checkoutSdk) {
      if (orderId == null) {
        return;
      }
      checkoutSdk.actions
        .addLinesFromOrder(orderId, sheetIds, undefined, undefined, undefined, true)
        .then(() => {
          addToCartState = 'successful';
        })
        .catch((e) => {
          addToCartState = 'failed';
          console.error('addSheetsToCart failed in ReorderButton', e);
        });
    } else {
      post(
        '/account/add_sheets',
        { sheets: sheetIds?.join(',') },
        Type.Object({
          cartItems: Type.Optional(Type.Number()),
          errors: Type.Array(
            Type.Object({
              sheet_id: Type.String(),
              message: Type.String(),
              code: Type.Optional(Type.Number()),
            }),
          ),
        }),
      )
        .then((result) => {
          if (result.errors.length > 0) {
            errorText =
              result.errors[0]?.code === 400
                ? translations.reorderCrossMarketError
                : result.errors[0].message;
            return Promise.reject(result.errors[0].message);
          }
          shoppingCart.refreshCart();
        })
        .then(() => {
          addToCartState = 'successful';
        })
        .catch(() => {
          addToCartState = 'failed';
        });
    }
  }
  const translations = getCommonTranslations();
  let addToCartState = $state<'initial' | 'successful' | 'failed' | 'loading'>('initial');
  let errorText: string | undefined = $state();
</script>

{#snippet label()}
  {#if addToCartState === 'initial'}
    {translations.addToCart}
  {:else if addToCartState === 'successful'}
    {translations.addedToCart}
  {:else if addToCartState === 'failed'}
    {translations.anErrorHasOccured}
  {:else if addToCartState === 'loading'}
    <Spinner sizeClass="mx-auto h-6 w-6" />
  {/if}
{/snippet}

<div class="flex justify-end">
  <Button
    class="float-right"
    onClick={addSheetsToCart}
    disabled={addToCartState === 'loading' || addToCartState === 'successful'}
    >{@render label()}</Button
  >
</div>
{#if errorText}
  <div class="flex justify-end">
    <Paragraph>{errorText}</Paragraph>
  </div>
{/if}
